export default __webpack_public_path__ + "static/media/no-record-img.82834287.png";